module.exports = __webpack_public_path__ + "img/9788988964187.f83b7690.jpg";